<template>
  <div class="motion-products">
    <div class="row">
      <div class="col-sm-12">
        <h2 class="section-header">
          <contentful-text :item="contentfulText('checkout-download-motion-product-head')" />
        </h2>
        <motion-product
          v-for="(product, productIndex) in products"
          :product="product"
          :key="productIndex"
          class="motion-products__item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MotionProduct from './MotionProduct/MotionProduct'

export default {
  name: 'MotionProducts',
  components: {
    MotionProduct
  },
  props: {
    products: { type: Array, default: null, required: true }
  },
  computed: {
    content () {
      return this.$store.state.viewModel.PageContent
    }
  }
}
</script>

<style lang="scss" scoped>
.motion-products {
  &__item {
    margin-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/MotionProducts.vue